import { useMutation, useQueryClient } from '@tanstack/react-query';
import axios from 'axios';
import { useParams } from 'react-router';

import type { ISurgeryOption } from '../types';

export default function useSurgeryService() {
  const queryClient = useQueryClient();
  const { patientUuid = '' } = useParams<{ patientUuid: string }>();
  const addAction = useMutation({
    mutationFn: async (data: Partial<ISurgeryOption>) => {
      const result = await axios.post<ISurgeryOption>(
        `/api/camel/patient_profile/clinical_info/surgery`,
        data,
      );
      invalidateClinicalQuery();
      return result?.data?.id;
    },
  });
  const editAction = useMutation({
    mutationFn: async ({
      data,
      surgeryId,
    }: {
      data: Partial<ISurgeryOption>;
      surgeryId: number;
    }) => {
      await axios.put(`/api/camel/patient_profile/clinical_info/surgery/${surgeryId}`, data);
      invalidateClinicalQuery();
    },
  });
  const deleteAction = useMutation({
    mutationFn: async (surgeryId: number) => {
      await axios.delete(`/api/camel/patient_profile/clinical_info/surgery/${surgeryId}`);
      invalidateClinicalQuery();
    },
  });

  const invalidateClinicalQuery = async () => {
    await queryClient.invalidateQueries({
      queryKey: ['camel', 'patient_profile', 'clinical_info', patientUuid],
    });
  };

  return {
    addSurgery: addAction.mutateAsync,
    editSurgery: editAction.mutateAsync,
    deleteSurgery: deleteAction.mutateAsync,
  };
}
